import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { IUserProfile } from "app/bundles/authorize/shared/user-profile";
declare let $: any;

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements AfterViewInit {
  @Input() title: string;
  @Input() showClose = true;
  @Input() enableModal = false;
  @Input() userProfile: IUserProfile = null;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();
  @Output() showModal = new EventEmitter<string>();
  modalEl = null;

  constructor(
    private _rootNode: ElementRef,
    private securityService: OAuthService,
  ) {}

  open() {
    this.modalEl.modal("show");
  }

  onClose() {
    this.showModal.emit("false");
    this.modalEl.modal("hide");
  }

  closeInternal() {
    this.onClose();
  }

  ngAfterViewInit() {
    this.modalEl = $(this._rootNode.nativeElement).find("div.modal");
  }

  has(selector) {
    return $(this._rootNode.nativeElement).find(selector).length;
  }

  logout() {
    this.securityService.logOut();
  }
}
